interface LatLngLiteral {
  lat: number;
  lng: number;
}

export function haversineDistance(
  pointA: LatLngLiteral,
  pointB: LatLngLiteral,
) {
  const toRad = (angle: number) => (angle * Math.PI) / 180;

  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(pointB.lat - pointA.lat);
  const dLon = toRad(pointB.lng - pointA.lng);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(pointA.lat)) *
      Math.cos(toRad(pointB.lat)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000; // Distance in meters
}
